import { DeepReadonlyObject } from 'rxdb';

import { ItineraryView, LegView } from '@mopla/data-models';

import { EPriceInfoKind, getPriceInfoKind } from './priceInfoKind';

/**
 * Returns all legs that require a /api/pricing/calculate call (e.g. 2 legs for KRK).
 *
 * Classified by mode alone: this runs before booking, when no leg carries a
 * `PricingView` yet — asking for the price is the whole point of the call.
 */
export function getAllPriceableLegs(itinerary: ItineraryView | null): LegView[];
export function getAllPriceableLegs(
	itinerary: DeepReadonlyObject<ItineraryView> | null
): DeepReadonlyObject<LegView>[];
export function getAllPriceableLegs(
	itinerary: ItineraryView | DeepReadonlyObject<ItineraryView> | null
): LegView[] | DeepReadonlyObject<LegView>[] {
	if (!itinerary) {
		return [];
	}

	return (itinerary.legs as LegView[]).filter(
		(leg) => getPriceInfoKind(leg.mode) === EPriceInfoKind.amount
	);
}
